import React from "react";
import { Card } from "../modules/TestInvoices";

export function InvoiceCardPage(props) {
  return <Card {...props} />;
}
